module.exports = __webpack_public_path__ + "cc597b569d920b7376b0756980b8712a.jpg";